import React, { Component } from "react";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import Axios from "axios";
import EventCard from "../../Components/Events/EventCard";
import noData from "../../Assets/img/noData.png";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import EventCard2 from "./eventdesc";
import { Modal } from "react-bootstrap";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event_data: [],
      loading: true,
      fakeData: [1, 2, 3],
      photoIndex: 0,
      isOpen: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Home";
    var dt = new Date();
    dt.setHours(dt.getHours() - 1);
    this.fetchEventData({
      session: this.props?.user?.session?.id,
    });
  }

  fetchEventData = (params = {}) => {
    Axios.get("/mApiV1/EventsList", { params: { ...params } })
      .then((res) => {
        console.log(res, "resres");
        this.setState({ event_data: res.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };

  render() {
    let { event_data, photoIndex, isOpen } = this.state;

    const handelDt = (dt) => {
      var j = dt % 10,
        k = dt % 100;
      if (j === 1 && k !== 11) {
        return dt + "st";
      }
      if (j === 2 && k !== 12) {
        return dt + "nd";
      }
      if (j === 3 && k !== 13) {
        return dt + "rd";
      }
      return dt + "th";
    };
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const handleDate = (date1, date2) => {
      let year1 = new Date(date1).getFullYear();
      let month1 = new Date(date1).getMonth();
      let dt1 = new Date(date1).getDate();

      let year2 = new Date(date2).getFullYear();
      let month2 = new Date(date2).getMonth();
      let dt2 = new Date(date2).getDate();

      year1 = year1 % 100;
      year2 = year2 % 100;
      if (year1 === year2) {
        if (month1 === month2) {
          if (dt1 === dt2) {
            return `${handelDt(dt1)} ${monthNames[month1]}, ${year1}`;
          } else {
            return `${handelDt(dt1)}-${handelDt(dt2)} ${
              monthNames[month1]
            }, ${year1}`;
          }
        } else {
          return `${handelDt(dt1)} ${monthNames[month1]} - ${handelDt(dt2)} ${
            monthNames[month2]
          }, ${year1}`;
        }
      } else {
        return `${handelDt(dt1)} ${monthNames[month1]}  ${year1} - ${handelDt(
          dt2
        )} ${monthNames[month2]}, ${year2}`;
      }
    };

    return (
      <div>
        <Header to="/home" title="Events" />
        <div className="container col-12 mt-3">
          {this.state.loading
            ? this.state.fakeData?.map((item, index) => {
                return (
                  <div className="mb-2" key={index}>
                    <EventCard loading={this.state.loading} />
                  </div>
                );
              })
            : null}

          {this.state?.event_data.length !== 0 && this.state.loading === false
            ? this.state.event_data?.map((item, index) => {
                return (
                  <div className="mb-2" key={index}>
                    <div
                      onClick={() =>
                        this.setState({
                          photoIndex: index % event_data.length,
                          isOpen: !this.state.isOpen,
                        })
                      }
                    >
                      <EventCard img={item?.event_image} />
                    </div>
                    <div>
                      <EventCard2
                        title={item?.event_name}
                        date={handleDate(item?.from_date, item.to_date)}
                        description={item?.description}
                      />
                    </div>
                  </div>
                );
              })
            : null}
          {isOpen && (
            <>
              <Lightbox
                mainSrc={event_data[photoIndex]?.event_image}
                imageTitle={event_data[photoIndex]?.event_name}
                imageCaption={event_data[photoIndex]?.description}
                nextSrc={
                  event_data[(photoIndex + 1) % event_data.length]?.event_image
                }
                prevSrc={
                  event_data[
                    (photoIndex + event_data.length - 1) % event_data.length
                  ]?.event_image
                }
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (photoIndex + event_data.length - 1) % event_data.length,
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex: (photoIndex + 1) % event_data.length,
                  })
                }
              />
              <div>sdvw</div>

              {/* <Modal
                // open={this.setState({ isOpen: true })}
                // onClose={this.setState({ isOpen: false })}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
              >
                <div style={{ width: 400 }}>
                  <h2 id="parent-modal-title">Text in a modal</h2>
                  <p id="parent-modal-description">
                    Duis mollis, est non commodo luctus, nisi erat porttitor
                    ligula.
                  </p>
                </div>
              </Modal> */}
            </>
          )}

          {this.state?.event_data.length === 0 &&
          this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">No Events Found!</p>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}
export default connect(mapStateToProps)(Events);
